import {Rental} from '../../../common/types/rental'

export interface ProductsPieData {
  product: string
  count: number
}

export const generateProductsPieData = (rentals: Rental[]): ProductsPieData[] => {
  const counts: Record<string, number> = {}

  rentals.forEach((rental) => {
    const productName = rental.product?.name
    if (!productName) return

    counts[productName] = (counts[productName] ?? 0) + 1
  })

  const total = Object.values(counts).reduce((sum, c) => sum + c, 0)

  return Object.entries(counts)
    .map(([product, count]) => ({
      product,
      count: total > 0 ? Math.round((count / total) * 100) : 0,
    }))
    .sort((a, b) => b.count - a.count)
}
